import { useState, useEffect } from 'react';

const DEFAULT_BREAKPOINT = 768;

/**
 * Returns true when viewport width is below the breakpoint (mobile).
 * @param breakpoint - Width in px (default 768)
 */
export function useBreakpoint(breakpoint: number = DEFAULT_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
